import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { EMPLOYMENT_TYPE_CHECKBOX_OPTIONS } from 'utils/constants/general/employmentTypes';

type Props = {
  variant?: SearchFacetVariant;
};
export function EmploymentTypeFacet({ variant = 'dropdown' }: Props) {
  // @ts-expect-error Fix type
  const selectedFacetValues = useSearchFacetSelectedValues('jobType');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="jobType"
      icon="hammer"
      label={
        <>
          {getText('Job Type')}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="jobType"
        initialValue={selectedFacetValues}
        options={EMPLOYMENT_TYPE_CHECKBOX_OPTIONS()}
      />
    </FacetVariant>
  );
}
